export default "__VITE_ASSET__xC7ZT1Dh__"